import {Directive} from '@angular/core';
import * as fromModal from 'app/_selectors/modal.selector';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ComponentLoaderService} from 'shared/_services/component-loader.service';
import {LoadableComponent} from '../../../projects/layout/src/_interface/loadableComponent';

@UntilDestroy()
@Directive({
	selector: '[appModal], app-modal'
})
export class ModalDirective {
	private openModal$ = this.store.select(fromModal.selectOpenModal).pipe(
		untilDestroyed(this),
		filter(({component}) => !!component)
	);
	private closeModal$ = this.store.select(fromModal.selectCloseModal).pipe(untilDestroyed(this));
	constructor(
		private store: Store,
		private modal: NgbModal,
		private loader: ComponentLoaderService
	) {
		this.openModal$.subscribe(({component, modalOptions, openPayload}) => {
			this.open(component, modalOptions, openPayload);
		});

		this.closeModal$.subscribe(this.close);
	}

	open = async <T>(lc: LoadableComponent, opts: NgbModalOptions, payload?: T) => {
		const comp = await this.loader.importComponent(lc);
		const compRef = this.modal.open(comp, opts);
		const instance = compRef.componentInstance;
		instance.payload = payload;
	}

	close = () => this.modal.dismissAll();
}
